export const setFlightCameras = "setFlightCameras";
export const setSelectedCamera = "setSelectedCamera";
export const setSidebarPanelIndex = "setSidebarPanelIndex";
export const setFilterImagesOnClick = "setFilterImagesOnClick";
export const setFilteredImages = "setFilteredImages";
